module.exports = __webpack_public_path__ + "images/09-05@2x_28a34406.png";